import type { CityConfig } from "../city-template/types";

export const steamboatSpringsConfig: CityConfig = {
  city: "Steamboat Springs",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "steamboat-springs",
  route: "/steamboat-springs",
  title: "Emergency Passport Steamboat Springs, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Steamboat Springs, Colorado — as fast as 24 hours. Same-day courier processing for Steamboat Springs, Craig, Hayden, Oak Creek, and all Routt County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Steamboat Springs, CO",
  heroSubtitle: "Ski trip to the Alps booked and your passport just expired? Destination wedding in the Caribbean leaving next week? We help Steamboat Springs residents — from ski area employees to downtown merchants to Routt County ranchers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Steamboat%20Springs%20Colorado%20winter%20wonderland%20with%20the%20iconic%20Steamboat%20Ski%20Resort%20slopes%20under%20fresh%20powder%20snow%2C%20the%20historic%20downtown%20on%20Lincoln%20Avenue%20with%20Western%20storefronts%20and%20the%20Yampa%20River%20flowing%20through%20town%2C%20Howelsen%20Hill%20ski%20jumping%20complex%20in%20the%20background%2C%20natural%20hot%20springs%20steam%20rising%20in%20the%20crisp%20mountain%20air%2C%20the%20Flat%20Tops%20wilderness%20on%20the%20horizon%2C%20golden%20hour%20light%20on%20fresh%20snow%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view&width=1800&height=700&seq=steamboat-hero-001&orientation=landscape",
  heroImageAlt: "Steamboat Springs Colorado with ski resort, downtown Lincoln Avenue, and Yampa River",
  geoPosition: "40.4850;-106.8317",
  geoPlacename: "Steamboat Springs, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 155 miles southeast via US-40 and I-70 — about 3 hours",
  },
  nearbyCitiesZips: [
    { name: "Steamboat Springs", zips: "80477, 80487, 80488" },
    { name: "Craig", zips: "81625, 81626" },
    { name: "Hayden", zips: "81639" },
    { name: "Oak Creek", zips: "80467" },
    { name: "Yampa", zips: "80483" },
    { name: "Phippsburg", zips: "80469" },
    { name: "Clark", zips: "80428" },
    { name: "Milner", zips: "80487" },
    { name: "Toponas", zips: "80479" },
    { name: "Kremmling", zips: "80459" },
    { name: "Walden", zips: "80430, 80480" },
    { name: "Meeker", zips: "81641" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Steamboat international departures via HDN or DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive 3 hours to Denver" },
    { icon: "ri-flight-takeoff-line", title: "HDN & DEN Airport Service", desc: "Same-day courier for Yampa Valley Regional and Denver International airports" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Steamboat or Craig" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Fort Collins, CO", route: "/fort-collins" },
    { name: "Fast passport renewal in Routt County", route: "/steamboat-springs" },
    { name: "Urgent passport services for Craig and Hayden", route: "/steamboat-springs" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in northwest Colorado", route: "/steamboat-springs" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Steamboat Springs remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Steamboat's northern Colorado location — 155 miles from the Colorado Passport Agency via US-40 over Rabbit Ears Pass — makes our courier service especially valuable. Skip the 3-hour mountain drive and let us handle everything.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Routt County and northwest Colorado",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Steamboat Springs and Routt County. From the ski resort base area and downtown Lincoln Avenue to the mountain residential neighborhoods, from the Strawberry Park hot springs area to the Fish Creek corridor — we serve every corner of Steamboat and the surrounding Yampa Valley.",
  nearbyCitiesIntro: "We serve Steamboat Springs and all nearby communities including Craig, Hayden, Oak Creek, Yampa, Phippsburg, Clark, Milner, and Toponas. We also serve Kremmling, Walden, Meeker, and the broader northwest Colorado region.",
  howItWorksIntro: "Most Steamboat travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 3 hours to Denver over Rabbit Ears Pass.",
  mistakesIntro: "Steamboat Springs is a world-famous ski destination and year-round outdoor recreation hub. The remote northwest Colorado location creates unique passport challenges. Here are the most common mistakes we see from Routt County travelers.",
  testimonialsIntro: "Steamboat Springs travelers — from winter ski enthusiasts to summer outdoor adventurers to year-round Yampa Valley residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Steamboat Springs, CO? Here are the most common ones we hear from Routt County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (3+ hours each way)", "Rabbit Ears Pass winter conditions"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive required — ship from Steamboat", "Perfect for international ski trips and ranch vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Steamboat Springs travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service without the 3-hour drive to Denver.",
      bullets: ["24–48 hour turnaround available", "HDN and DEN airport departure support", "Winter ski season travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Steamboat adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Routt County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Steamboat residents and Routt County families — including seasonal workers and new Yampa Valley residents.",
      bullets: ["Acceptance facility scheduling in Steamboat or Craig", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Steamboat residents who lost their passport before international travel — ski season or summer adventure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Steamboat and Routt County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Steamboat and Routt County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Steamboat Springs CO", description: "Urgent passport processing for Steamboat Springs Colorado travelers with immediate departure needs from HDN or DEN." },
    { name: "Expedited Passport Renewal Steamboat Springs CO", description: "Fast passport renewal for Steamboat Springs Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Steamboat Springs CO", description: "New passport application services for Steamboat Springs Colorado residents applying for their first passport." },
    { name: "Child Passport Steamboat Springs CO", description: "Minor passport services for Steamboat Springs Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Todd B.",
      location: "Steamboat Springs, CO — Ski Area",
      rating: 5,
      text: "Had a heli-skiing trip to British Columbia booked and realized my passport was expired. Fast Passport Center got it renewed in 2 days. Impossible to drive to Denver with ski season traffic and Rabbit Ears Pass conditions.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Megan W.",
      location: "Hayden, CO",
      rating: 5,
      text: "Family trip to Norway over winter break. Three passports — my renewal and two first-time for the kids. Done in 5 days. Unbelievable service for northwest Colorado.",
      service: "Family Passport Bundle",
    },
    {
      name: "Ranch Owner K.",
      location: "Clark, CO",
      rating: 5,
      text: "Business trip to Argentina for cattle operations with one week notice. Fast Passport Center handled everything. From Clark, there's no practical way to get to Denver for passport services — this is essential for rural Routt County.",
      service: "Emergency Passport",
    },
    {
      name: "Ashley P.",
      location: "Steamboat Springs, CO — Downtown",
      rating: 5,
      text: "Lost my passport during a move and had a trip to New Zealand in two weeks. Replaced in 3 days. The daily updates gave me so much peace of mind. Fantastic service for the Yampa Valley.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "stb-1",
      name: "Steamboat Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Lincoln Ave",
      city: "Steamboat Springs",
      state: "CO",
      zip: "80477",
      phone: "(970) 879-0170",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Steamboat Springs, on Lincoln Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Steamboat acceptance facility. Appointments required — book 2–3 weeks ahead during ski season (November–April). Limited hours during shoulder seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "stb-2",
      name: "Craig Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "556 Pershing St",
      city: "Craig",
      state: "CO",
      zip: "81625",
      phone: "(970) 824-5578",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Craig, approximately 42 miles west of Steamboat via US-40",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in northwest Colorado. Better appointment availability than Steamboat. Serves Moffat County and western Routt County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "stb-3",
      name: "Routt County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "522 Lincoln Ave",
      city: "Steamboat Springs",
      state: "CO",
      zip: "80487",
      phone: "(970) 870-5556",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Steamboat Springs downtown, Routt County Courthouse",
      website: "https://www.co.routt.co.us/",
      websiteLabel: "Routt County Clerk",
      notes: "County clerk passport acceptance. Extended hours compared to post office. Convenient downtown location in the historic courthouse.",
      icon: "ri-government-line",
    },
    {
      id: "stb-4",
      name: "Hayden Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "138 S Poplar St",
      city: "Hayden",
      state: "CO",
      zip: "81639",
      phone: "(970) 276-3741",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Hayden, approximately 25 miles west of Steamboat via US-40",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small facility serving Hayden and Yampa Valley Airport area residents. Very limited hours — call ahead. Close to Yampa Valley Regional Airport (HDN).",
      icon: "ri-mail-line",
    },
    {
      id: "stb-5",
      name: "Oak Creek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 E Main St",
      city: "Oak Creek",
      state: "CO",
      zip: "80467",
      phone: "(970) 736-2437",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Oak Creek, approximately 20 miles south of Steamboat via CO-131",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small facility serving southern Routt County. Limited hours and appointment slots. Good backup option.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3hr drive to Denver via Rabbit Ears Pass", fpc: "No — ship from Steamboat" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Winter Road Conditions", agency: "Rabbit Ears Pass can be treacherous", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Ski Season Peak",
      description: "Steamboat's busiest periods — Christmas/New Year, Presidents' Week, and spring break — overlap with peak passport demand. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before departure.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photos",
      description: "Passport photos in Steamboat can be hit-or-miss. Make sure photos meet strict requirements — exactly 2×2 inches on a pure white background. No ski goggles, hats, or winter gear.",
    },
    {
      icon: "ri-roadster-line",
      title: "Underestimating Rabbit Ears Pass",
      description: "The drive to Denver requires crossing Rabbit Ears Pass (9,426 ft) on US-40 and then navigating I-70 traffic. In winter, this 3-hour drive can become 5+ hours or be closed entirely. Our courier service eliminates this risk.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Not Using Yampa Valley Regional Airport (HDN)",
      description: "HDN is 25 miles west of Steamboat in Hayden. It offers seasonal direct flights to major hubs. Many Steamboat residents don't realize they can avoid the 3-hour DEN drive for domestic connections, simplifying their international travel planning.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "European countries require 6 months of passport validity beyond your planned stay. Steamboat's international ski crowd frequently faces this issue when booking last-minute trips to the Alps or South America.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early",
      description: "Steamboat's post office has very limited hours and appointment slots. During ski season and summer tourist months, appointments can be 3–4 weeks out. The Routt County Clerk or Craig Post Office are good alternatives with better availability.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Steamboat or Routt County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at UPS or FedEx in Steamboat or Craig." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Yampa Valley documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no Rabbit Ears Pass drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Steamboat address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Steamboat Springs, CO?", a: "Fast Passport Center offers emergency passport processing in Steamboat Springs, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 155-mile, 3-hour drive over Rabbit Ears Pass to the Colorado Passport Agency." },
    { q: "Does Steamboat Springs have its own passport agency?", a: "No — Steamboat Springs does not have a regional passport agency. The nearest is the Colorado Passport Agency (155 miles southeast via US-40 and I-70, crossing Rabbit Ears Pass at 9,426 feet). Fast Passport Center's courier service means Routt County residents never need to make this drive." },
    { q: "What's the closest airport to Steamboat Springs for international travel?", a: "Yampa Valley Regional Airport (HDN) is 25 miles west of Steamboat in Hayden. It offers seasonal direct flights to major hubs like DEN, DFW, ORD, and ATL. Denver International Airport (DEN) is approximately 175 miles southeast — about 3.5 hours by car. Most international travel from Steamboat connects through DEN." },
    { q: "Can you serve residents in Craig, Hayden, and Oak Creek?", a: "Absolutely. Fast Passport Center serves all of Routt County including Craig (Moffat County), Hayden, Oak Creek, Yampa, Phippsburg, Clark, Milner, and Toponas. We also serve Kremmling, Walden, Meeker, and all of northwest Colorado." },
    { q: "What if I'm only in Steamboat for ski season?", a: "Fast Passport Center serves both full-time Routt County residents and seasonal residents. If you split your time between Steamboat and another location, we can work with whichever address is most convenient. Many of our clients are second-home owners and seasonal ski area employees." },
    { q: "How much does an expedited passport cost in Steamboat Springs, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote — our courier service provides exceptional value compared to the alternative of a 6-hour round trip to Denver." },
    { q: "Where can I get passport photos in Steamboat Springs?", a: "City Market (1825 Central Park Dr) and Walgreens (1805 Central Park Dr) offer passport photo services. The UPS Store in Craig (42 miles west) is another option. Always call ahead — Steamboat is a small town and photo services can be limited." },
    { q: "Does winter weather affect expedited passport service to Steamboat?", a: "Winter weather can affect shipping to Steamboat, especially when Rabbit Ears Pass has chain laws or closures. We recommend building in 1–2 buffer days during peak winter (December–March). Our team monitors weather and adjusts shipping accordingly." },
  ],
  photoLocations: [
    { name: "City Market — Steamboat", address: "1825 Central Park Dr, Steamboat Springs, CO 80487", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Steamboat", address: "1805 Central Park Dr, Steamboat Springs, CO 80487", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Craig", address: "1111 W Victory Way, Craig, CO 81625", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "Walmart — Craig", address: "2000 W Victory Way, Craig, CO 81625", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    { name: "DMV — Steamboat Springs (Routt County)", address: "136 6th St, Steamboat Springs, CO 80487", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Routt County residents. REAL ID and driver's license renewals. Convenient downtown location near the courthouse.", featured: true },
    { name: "DMV — Craig (Moffat County)", address: "221 W Victory Way, Craig, CO 81625", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for western Routt County and Moffat County residents. REAL ID processing available. Approximately 42 miles from Steamboat.", featured: false },
  ],
  airports: [
    {
      code: "HDN",
      name: "Yampa Valley Regional Airport",
      distance: "25 miles west of Steamboat Springs via US-40",
      address: "11005 Co Rd 51A, Hayden, CO 81639",
      note: "Steamboat's closest airport with commercial service. Seasonal flights (winter/summer) to DEN, DFW, ORD, ATL, IAH, EWR, and other hubs. No international service — all international travel requires connection through a major hub. Approximately 30-minute drive from Steamboat.",
      flightUrl: "https://www.steamboatsprings.net/airport",
      flightLabel: "HDN Flight Info",
      featured: true,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "175 miles southeast of Steamboat via US-40, CO-9, and I-70",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport. Approximately 3.5-hour drive from Steamboat. Nonstop flights to Europe, Asia, and the Americas. Route crosses Rabbit Ears Pass — winter conditions can add significant travel time.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: false,
    },
    {
      code: "EGE",
      name: "Eagle County Regional Airport",
      distance: "95 miles south of Steamboat via CO-131",
      address: "219 Eldon Wilson Rd, Gypsum, CO 81637",
      note: "Alternative regional airport. Winter seasonal international flights available. Approximately 2-hour drive from Steamboat. Good option when HDN flights are limited.",
      flightUrl: "https://www.eaglecounty.us/airport",
      flightLabel: "EGE Flight Info",
      featured: false,
    },
  ],
};